import * as React from 'react'
import { cn } from '@/lib/utils'

interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  value: number // 0-100
  showLabel?: boolean
  size?: 'sm' | 'md' | 'lg'
}

const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ className, value, showLabel = false, size = 'md', ...props }, ref) => {
    const clampedValue = Math.max(0, Math.min(100, value))
    const heightClass = size === 'sm' ? 'h-1' : size === 'md' ? 'h-1.5' : 'h-2'

    return (
      <div
        ref={ref}
        className={cn(
          'bg-muted relative w-full overflow-hidden rounded-full',
          heightClass,
          className
        )}
        {...props}
      >
        <div
          className={cn(
            'bg-primary h-full rounded-full transition-all duration-300 ease-in-out',
            heightClass
          )}
          style={{ width: `${clampedValue}%` }}
          role="progressbar"
          aria-valuenow={clampedValue}
          aria-valuemin={0}
          aria-valuemax={100}
        />
        {showLabel && (
          <div className="text-foreground absolute inset-0 flex items-center justify-center text-xs font-medium">
            {Math.round(clampedValue)}%
          </div>
        )}
      </div>
    )
  }
)
Progress.displayName = 'Progress'

export { Progress }
